// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.techstack-model {
    width: 70%;
    margin: auto;
    text-align: center;
    margin-bottom: 10rem;
}

.techstack-options {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;

    & button {
        padding: 12px 40px;
        font-size: 1.1rem;
        font-weight: bold;
        cursor: pointer;
        border: 1px solid gray;
        border-radius: 20px;
        background-color: white;
    }
}

.techstack-heading {
    font-size: 3rem;
    margin: 0;
}

.techstack-desc {
    font-size: 1.3rem;

}

.techstack-heading-bold {
    font-weight: bold;
}

.techstack-container {
    display: grid;
    border-radius: 1rem;
    grid-template-columns: repeat(5, 1fr);
    box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;
    padding: 2rem;
    gap: 1rem;

    & div {
        margin: auto;
        padding: 32px 16px;
        font-size: 1rem;
        font-weight: 700;
        border-radius: 8px;
        text-align: center;
        width: 70%;
        height: max-content;
        box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;

        & img {
            width: 50%;
            height: auto;
            aspect-ratio: 1/1;
        }
    }
}


@media screen and (min-width:300px) and (max-width:490px) {
    .techstack-model {
        width: 90%;
        margin-bottom: var(--margin-bottom-mobile);
    }

    .techstack-heading {
        font-size: var(--font-size8);
    }

    .techstack-desc {
        font-size: 0.75rem;
    }

    .techstack-options {
        flex-direction: column;

        & button {
            width: 100%;
            text-align: left;
            padding: 15px 0 20px;
            border-radius: 0;
            border: none;
            border-bottom: 1px solid lightgray;
            padding-left: 5%;
        }
    }

    .techstack-container {
        grid-template-columns: repeat(2, 1fr);
        padding: 0.5rem;

        & div {
            width: 70%;
            height: 100px;

            & img {
                width: 50%;
                height: 50px;
            }
        }


    }
}

@media screen and (min-width:601px) and (max-width:1030px) {
    .techstack-model {
        width: 90%;
        margin-bottom: var(--margin-bottom-mobile);
    }

    .techstack-heading {
        font-size: var(--font-size8);
    }

    .techstack-desc {
        font-size: 0.85rem;
    }

    .techstack-options {
        flex-direction: column;

        & button {
            width: 100%;
            text-align: left;
            padding: 15px 0 20px;
            border-radius: 0;
            border: none;
            border-bottom: 1px solid lightgray;
            padding-left: 5%;
        }
    }

    .techstack-container {
        grid-template-columns: repeat(3, 1fr);
        padding: 1rem;

        & div {
            width: 70%;
            height: 150px;
        }

        & img {
            width: 20%;
            height: auto;
        }
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Homepage/Section8.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;;IAEnB;QACI,kBAAkB;QAClB,iBAAiB;QACjB,iBAAiB;QACjB,eAAe;QACf,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;IAC3B;AACJ;;AAEA;IACI,eAAe;IACf,SAAS;AACb;;AAEA;IACI,iBAAiB;;AAErB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,8CAA8C;IAC9C,aAAa;IACb,SAAS;;IAET;QACI,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,kBAAkB;QAClB,UAAU;QACV,mBAAmB;QACnB,8CAA8C;;QAE9C;YACI,UAAU;YACV,YAAY;YACZ,iBAAiB;QACrB;IACJ;AACJ;;;AAGA;IACI;QACI,UAAU;QACV,0CAA0C;IAC9C;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;;QAEtB;YACI,WAAW;YACX,gBAAgB;YAChB,oBAAoB;YACpB,gBAAgB;YAChB,YAAY;YACZ,kCAAkC;YAClC,gBAAgB;QACpB;IACJ;;IAEA;QACI,qCAAqC;QACrC,eAAe;;QAEf;YACI,UAAU;YACV,aAAa;;YAEb;gBACI,UAAU;gBACV,YAAY;YAChB;QACJ;;;IAGJ;AACJ;;AAEA;IACI;QACI,UAAU;QACV,0CAA0C;IAC9C;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;;QAEtB;YACI,WAAW;YACX,gBAAgB;YAChB,oBAAoB;YACpB,gBAAgB;YAChB,YAAY;YACZ,kCAAkC;YAClC,gBAAgB;QACpB;IACJ;;IAEA;QACI,qCAAqC;QACrC,aAAa;;QAEb;YACI,UAAU;YACV,aAAa;QACjB;;QAEA;YACI,UAAU;YACV,YAAY;QAChB;IACJ;AACJ","sourcesContent":[".techstack-model {\r\n    width: 70%;\r\n    margin: auto;\r\n    text-align: center;\r\n    margin-bottom: 10rem;\r\n}\r\n\r\n.techstack-options {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-bottom: 1rem;\r\n\r\n    & button {\r\n        padding: 12px 40px;\r\n        font-size: 1.1rem;\r\n        font-weight: bold;\r\n        cursor: pointer;\r\n        border: 1px solid gray;\r\n        border-radius: 20px;\r\n        background-color: white;\r\n    }\r\n}\r\n\r\n.techstack-heading {\r\n    font-size: 3rem;\r\n    margin: 0;\r\n}\r\n\r\n.techstack-desc {\r\n    font-size: 1.3rem;\r\n\r\n}\r\n\r\n.techstack-heading-bold {\r\n    font-weight: bold;\r\n}\r\n\r\n.techstack-container {\r\n    display: grid;\r\n    border-radius: 1rem;\r\n    grid-template-columns: repeat(5, 1fr);\r\n    box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;\r\n    padding: 2rem;\r\n    gap: 1rem;\r\n\r\n    & div {\r\n        margin: auto;\r\n        padding: 32px 16px;\r\n        font-size: 1rem;\r\n        font-weight: 700;\r\n        border-radius: 8px;\r\n        text-align: center;\r\n        width: 70%;\r\n        height: max-content;\r\n        box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;\r\n\r\n        & img {\r\n            width: 50%;\r\n            height: auto;\r\n            aspect-ratio: 1/1;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n@media screen and (min-width:300px) and (max-width:490px) {\r\n    .techstack-model {\r\n        width: 90%;\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n    }\r\n\r\n    .techstack-heading {\r\n        font-size: var(--font-size8);\r\n    }\r\n\r\n    .techstack-desc {\r\n        font-size: 0.75rem;\r\n    }\r\n\r\n    .techstack-options {\r\n        flex-direction: column;\r\n\r\n        & button {\r\n            width: 100%;\r\n            text-align: left;\r\n            padding: 15px 0 20px;\r\n            border-radius: 0;\r\n            border: none;\r\n            border-bottom: 1px solid lightgray;\r\n            padding-left: 5%;\r\n        }\r\n    }\r\n\r\n    .techstack-container {\r\n        grid-template-columns: repeat(2, 1fr);\r\n        padding: 0.5rem;\r\n\r\n        & div {\r\n            width: 70%;\r\n            height: 100px;\r\n\r\n            & img {\r\n                width: 50%;\r\n                height: 50px;\r\n            }\r\n        }\r\n\r\n\r\n    }\r\n}\r\n\r\n@media screen and (min-width:601px) and (max-width:1030px) {\r\n    .techstack-model {\r\n        width: 90%;\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n    }\r\n\r\n    .techstack-heading {\r\n        font-size: var(--font-size8);\r\n    }\r\n\r\n    .techstack-desc {\r\n        font-size: 0.85rem;\r\n    }\r\n\r\n    .techstack-options {\r\n        flex-direction: column;\r\n\r\n        & button {\r\n            width: 100%;\r\n            text-align: left;\r\n            padding: 15px 0 20px;\r\n            border-radius: 0;\r\n            border: none;\r\n            border-bottom: 1px solid lightgray;\r\n            padding-left: 5%;\r\n        }\r\n    }\r\n\r\n    .techstack-container {\r\n        grid-template-columns: repeat(3, 1fr);\r\n        padding: 1rem;\r\n\r\n        & div {\r\n            width: 70%;\r\n            height: 150px;\r\n        }\r\n\r\n        & img {\r\n            width: 20%;\r\n            height: auto;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
